import React, { useEffect, useState } from "react";
import { Sparkles, Heart, Wallet, Compass } from "lucide-react";
import client, { money } from "@/lib/api";
import { addToList } from "@/pages/Home";
import { Skeleton } from "@/components/ui/skeleton";

const ICONS = { regulars: Heart, brands: Sparkles, budget: Wallet, discover: Compass };

const Item = ({ c, testId, onAdd }) => (
  <div data-testid={testId} className="shrink-0 w-44 sm:w-48 snap-start bg-white rounded-2xl p-2.5 pp-shadow flex flex-col transition-transform duration-200 hover:-translate-y-1">
    <div className="h-32 rounded-xl bg-white grid place-items-center overflow-hidden"><img src={c.image} alt={c.name} loading="lazy" className="max-h-full max-w-full object-contain" /></div>
    <span className="mt-2 self-start rounded-full bg-[#EBF7EE] text-pp-forest text-[10px] font-bold px-2 py-0.5 truncate max-w-full">{c.reason}</span>
    <p className="mt-1 text-[11px] font-bold uppercase text-pp-muted truncate">{c.brand || "\u00a0"}</p>
    <p className="text-sm font-bold text-pp-text line-clamp-2 min-h-[2.5rem]">{c.name}</p>
    <div className="flex items-baseline gap-1.5"><span className="text-lg font-extrabold text-pp-forest">{money(c.price)}</span>
      {c.was_price && <span className="text-xs text-pp-muted line-through">{money(c.was_price)}</span>}</div>
    <p className="text-[11px] text-pp-muted truncate">{c.size} · {c.store_banner}</p>
    <button type="button" onClick={() => onAdd({ name: `${c.brand} ${c.name} ${c.size}`.trim() })} data-testid={`${testId}-add`}
      className="mt-auto pt-2"><span className="block w-full rounded-full bg-pp-forest text-white text-xs font-bold py-1.5">+ Add to my list</span></button>
  </div>
);

export default function ForYou({ onAdded }) {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/personal/for-you").then((r) => setD(r.data)).catch(() => setD({ sections: [] })); }, []);
  const add = async (x) => { await addToList(x); onAdded?.(); };
  if (!d) return <Skeleton className="h-64 rounded-3xl" />;
  if (!d.sections.length) return null;
  return (
    <section className="space-y-6" data-testid="for-you">
      <div>
        <h2 className="text-xl font-extrabold text-pp-text">{d.personalized ? "Picked for you" : "Popular picks near you"}</h2>
        <p className="text-xs text-pp-muted">{d.personalized ? "Based on what you buy, plus new things to try" : "Shop a few trips and we'll tailor this to you"}</p>
      </div>
      {d.sections.map((s) => {
        const Icon = ICONS[s.key] || Sparkles;
        return (
          <div key={s.key} data-testid={`for-you-${s.key}`}>
            <h3 className="flex items-center gap-2 font-extrabold text-pp-text mb-2"><Icon className="h-4 w-4 text-pp-gold" /> {s.title}</h3>
            <div className="flex gap-3 overflow-x-auto snap-x py-1 pb-3 scrollbar-none">
              {s.items.map((c, i) => <Item key={`${c.brand}-${c.name}-${c.size}`} c={c} testId={`for-you-${s.key}-${i}`} onAdd={add} />)}
            </div>
          </div>
        );
      })}
    </section>
  );
}
